// Shared formatting helpers for dashboard/employee/report pages.

export function formatDuration(totalSeconds) {
    const secs = Math.max(0, Math.floor(Number(totalSeconds) || 0));
    const h = Math.floor(secs / 3600);
    const m = Math.floor((secs % 3600) / 60);
    return `${h}h ${m}m`;
}

export function formatHoursDecimal(totalSeconds) {
    return (Math.max(0, Number(totalSeconds) || 0) / 3600).toFixed(1);
}

// Local YYYY-MM-DD (matches what the API expects — same format the old
// dashboard and the desktop app use).
export function toDateString(d) {
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
}

export function todayString() {
    return toDateString(new Date());
}

export function yesterdayString() {
    const d = new Date();
    d.setDate(d.getDate() - 1);
    return toDateString(d);
}

// Monday of the current week
export function startOfWeekString() {
    const d = new Date();
    const day = d.getDay(); // 0=Sun..6=Sat
    d.setDate(d.getDate() - (day === 0 ? 6 : day - 1));
    return toDateString(d);
}

export function startOfMonthString() {
    const d = new Date();
    d.setDate(1);
    return toDateString(d);
}

// Formats an ISO datetime (or a plain already-formatted time string, which
// some Log fields — e.g. session_ended — may already be) as HH:MM.
export function formatTime(value) {
    if (!value) return '—';
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
}

const WEEKDAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];
const MONTHS_SHORT = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Formats a 'YYYY-MM-DD' date as "Thur, 10 Sep 2026" — built manually (not
// toLocaleDateString) so the order/tokens are fixed regardless of locale.
export function formatDateLabel(dateStr) {
    if (!dateStr) return '—';
    const [y, m, d] = dateStr.split('-').map(Number);
    if (!y || !m || !d) return dateStr;
    const dd = String(d).padStart(2, '0');
    return `${WEEKDAYS_SHORT[new Date(y, m - 1, d).getDay()]}, ${dd} ${MONTHS_SHORT[m - 1]} ${y}`;
}

export function getInitials(name) {
    if (!name) return 'U';
    const parts = name.trim().split(' ');
    return parts.length > 1
        ? (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
        : name.substring(0, 2).toUpperCase();
}
